import React, {useState} from 'react';
import {InfoIcon, XIcon} from 'assests/GmsIcons';
import Tooltip from "../../../../Components/GMS/Rules/Components/Tooltip";

type MerchantSettingsProps = {
    merchantSettings: any[];
    onClose: () => void;
    onSubmit: (categories: []) => void;
}

const MerchantSettings = ({merchantSettings: initialSettings, onClose, onSubmit}: MerchantSettingsProps) => {

    const [merchantSettings, setMerchantSettings] = useState<any>(initialSettings);

    const handleBoolChange = (e: any, index: number) => {
        const updatedItems = merchantSettings.map((e: any, i: number) => i === index ? {...e, value: !e.value} : e)
        setMerchantSettings(updatedItems);
    }

    const handleChangeInput = (value: string, index: number) => {
        const updatedItems = merchantSettings.map((e: any, i: number) => i === index ? {...e, value: `${value}`} : e)
        setMerchantSettings(updatedItems);
    }

    const renderChips = (e: any, index: number) => {
        return <div id="merchant-settings-dialog" className={`tw-mt-[8px]`}>
            {e.lov.map((lovValue: any) => {
                const found = e.value.includes(lovValue);
                return <div key={lovValue} onClick={() => {
                    const updatedItems = merchantSettings.map((e: any, i: number) => {
                        if (i !== index) {
                            return e;
                        }
                        if (found) {
                            return {...e, value: e.value.filter((e: any) => e !== lovValue)};
                        }
                        return {...e, value: [...e.value, lovValue]};
                    })
                    setMerchantSettings(updatedItems);
                }}
                            className={`tw-mr-[4px] tw-mb-[2px] tw-h-auto tw-px-3 ${found ? 'tw-bg-[#1E40AF]' : 'tw-bg-[#ffffff]'} tw-rounded-[44px] tw-border tw-justify-center tw-items-center tw-gap-1 tw-inline-flex tw-cursor-pointer`}>
                    <div
                        className={`${found ? 'tw-text-[#ffffff]' : 'tw-text-[#1E40AF]'} tw-text-xs tw-font-medium tw-font-['Noto Sans']`}>{lovValue}
                    </div>
                </div>;
            })}
        </div>
    }

    const renderValues = (e: any, index: number) => {
        switch (e.type) {
            case 'array':
                return <div className="flex-none tw-w-[125px] tw-my-[8px]">
                    <select className="shadow-none form-select drop-down-dm tw-ps-3"
                            value={e.value ?? ''} onChange={(e) => handleChangeInput(e.target.value, index)}>
                        {e.lov && e.lov.map((item: any, index: number) => {
                            return (
                                <option value={item} key={item + index}>
                                    {item}
                                </option>);
                        })}
                    </select>
                </div>;
            case 'string':
                return <div className="flex-none tw-w-[124px] tw-ml-[10px] tw-my-[8px]">
                    <input
                        className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-9 tw-px-2.5 tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"
                        type='text'
                        value={e.value}
                        onChange={(e) => {
                            handleChangeInput(e.target.value, index)
                        }}
                        placeholder={'Enter ID'}
                    />
                </div>;
            case 'number':
                return <div className="flex-none tw-w-[62px] tw-ml-[10px] tw-my-[8px]">
                    <input
                        className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-9 tw-px-2.5 tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"
                        type='number'
                        step="any"
                        value={e.value}
                        onChange={(e) => {
                            handleChangeInput(e.target.value, index)
                        }}
                        placeholder={''}
                    />
                </div>;
            case 'boolean':
                return <div className="flex-none tw-w-[50px] tw-ml-[10px]">

                    <label
                        className='tw-autoSaverSwitch tw-relative tw-inline-flex tw-cursor-pointer tw-select-none tw-items-center'>
                        <input
                            type='checkbox'
                            name='autoSaver'
                            className='tw-sr-only'
                            checked={e.value}
                            onChange={(e) => handleBoolChange(e, index)}
                        />
                        <span
                            className={`tw-slider tw-mr-3 tw-flex tw-h-[26px] tw-w-[50px] tw-items-center tw-rounded-full tw-p-1 tw-duration-200 tw-my-[12px] ${
                                e.value ? 'tw-bg-[#488328]' : 'tw-bg-[#C9CCCF]'
                            }`}
                        >
                    <span
                        className={`tw-dot tw-h-[18px] tw-w-[18px] tw-rounded-full tw-bg-white tw-duration-200 ${
                            e.value ? 'tw-translate-x-6' : ''
                        }`}
                    />
                    </span>
                        {/* <span className='tw-label tw-flex tw-items-center tw-text-sm tw-font-medium tw-text-black'>
                    Auto Saver
                    </span> */}
                    </label>
                </div>;
            default:
                return '';
        }
    }

    return (
        <div className="tw-w-[432px] tw-absolute tw-h-[95vh] tw-bg-white tw-shadow tw-float-right tw-right-0 tw-top-0 tw-overflow-y-scroll"
            style={{zIndex: 1000}}>
            <div className="tw-text-sky-950 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-tight tw-my-[18px] tw-mx-[12px]">{'Merchant Settings'}</div>
            <button className="tw-text-black tw-float-right tw-my-[-36px] tw-mx-[24px]" onClick={() => onClose()}>
                <XIcon/>
            </button>
            <div className="tw-w-[373px] tw-h-[0px] tw-border-zinc-300"/>

            <div className="tw-m-[16px] tw-text-[#6d788c] tw-text-sm tw-font-normal tw-font-['Noto Sans'] tw-leading-tight">Confirm
                your selection -
            </div>

            {merchantSettings.map((e: any, index: number) => {

                return <div key={e.config_attr} className={`tw-items-center tw-px-[16px] ${Array.isArray(e.value) ? 'tw-py-[8px]' : ''} ${((index + 1) === merchantSettings.length) ? 'tw-border-b-[1px]' : ''} tw-border-t-[1px] tw-border-[#d1d1d6]`}>
                    <div className="tw-flex">
                        <div className="tw-flex-auto tw-flex tw-items-center">
                            <div className="tw-text-black tw-text-sm tw-font-normal tw-font-['Noto Sans'] tw-me-[5px]">{e.title}</div>
                            <div className="tw-me-[5px]">
                                <Tooltip text={e.description}>
                                    <InfoIcon/>
                                </Tooltip>
                            </div>
                        </div>
                        {!Array.isArray(e.value) ? renderValues(e, index) : null}
                    </div>
                    {Array.isArray(e.value) ? renderChips(e, index) : null}
                </div>;
            })}

            <div className="tw-w-[88px] tw-h-8 px-[22px] tw-py-2 tw-bg-blue-800 tw-rounded tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex tw-cursor-pointer tw-mt-[9px] tw-mb-[36px] tw-mx-[16px]">
                <div className="tw-text-center tw-text-white tw-text-sm tw-font-normal tw-font-['Noto Sans'] tw-leading-tight tw-cursor-pointer"
                    onClick={() => {
                        onSubmit(merchantSettings);
                    }}>Done
                </div>
            </div>
        </div>
    );
}

export default MerchantSettings;
